import React, { useState } from "react";
import {
  Modal,
  Button,
  Row,
  Col,
  Form,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { IconMail } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { API_ENDPOINTS } from "../../../constant/_constant";
import usePostRequest from "../../../hooks/usePostRequest";
import { toast } from "react-toastify";

function SendMail({ show, onClose, toEmail, orderId }) {
  const [formData, setFormData] = useState({
    from_email: "platform_admin@aspettoinc.com",
    to_email: toEmail || "",
    order_id: orderId,
  });

  const { isLoading: sendLoading, postData: SendCustomerFeedback } =
    usePostRequest(API_ENDPOINTS.GENERATE_FEEDBACK_LINK);

  const onSuccess = (response) => {
    toast.success("Email sent successfully!");
    onClose();
  };

  const onError = (error) => {
    toast.error(error?.message || "Failed to send email.");
  };

  const handleGenerate = () => {
    if (!formData.to_email) {
      toast.warning("Please enter a recipient email.");
      return;
    }

    SendCustomerFeedback(formData, onSuccess, onError);
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <div>
        <Modal.Title>Send Mail</Modal.Title>
        <p className="mb-0">Quote Number: {orderId}</p>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={12} className="mb-3">
              <Form.Label>From</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconMail stroke={1} />
                </InputGroup.Text>
                <Form.Control value={formData.from_email} disabled />
              </InputGroup>
            </Col>

            <Col md={12} className="mb-3">
              <Form.Label>To</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconMail stroke={1} />
                </InputGroup.Text>
                <Form.Control
                  type="email"
                  placeholder="Recipient Email"
                  value={formData.to_email}
                  onChange={(e) =>
                    setFormData({ ...formData, to_email: e.target.value })
                  }
                />
              </InputGroup>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="warning"
          onClick={handleGenerate}
          disabled={sendLoading}
        >
          {sendLoading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            "Generate"
          )}
        </Button>
        <Button variant="outline-secondary" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SendMail;
